import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useDaily, useAudioLevel, useAudioTrack, useLocalSessionId } from '@daily-co/daily-react';
import { useNavigate, useParams } from 'react-router-dom';
import { useRecoilState, useSetRecoilState } from 'recoil';
import {
  pageAtom,
  isAuthAtom,
  myNftAtom,
  myNftBackAtom,
  displayNameAtom,
  topMessageAtom,
  webcamAtom,
  showEditNameAtom,
  recordLocalAtom,
  authUserTypeAtom,
  recordTypeAtom,
} from '../../State';
import { ReactComponent as AIWhite } from '../Images/buttons/aibutton.svg';
import { ReactComponent as AIBlack } from '../Images/buttons/selectModeAIBlack.svg';
import { ReactComponent as FaceWhite } from '../Images/buttons/faceButton.svg';
import { ReactComponent as LocalBlack } from '../Images/buttons/localIcon.svg';
import { ReactComponent as CloudBlack } from '../Images/buttons/cloudIcon.svg';
import './Call.css';
import NFT from '../NFT/NFT';
import NFT2 from '../NFT/NFT2';
import NFTDetail from '../NFT/NFTDetail';
import DataModel from '../Util/DataModel';
import isElectron from '../../Global';
import Loading from '../Loading/Loading';
import { useTranslation } from 'react-i18next';

//ヘアーチェック
export default function Record({ joinCall, preAuthCompleteState, selectFace = false }) {
  //daily系
  const callObject = useDaily();

  const urlParam = useParams();
  var roomID = urlParam.id; //URL取得
  let showThisNFT = roomID == 'makopt' || roomID == '144987874' ? true : false;

  //const localParticipant = useLocalParticipant(); //pre joinが完了したああとじゃないと値が取れない
  // const localSessionId = useLocalSessionId();
  // const audioTrack = useAudioTrack(localSessionId);

  //recoil系
  const [pageState, setPageState] = useRecoilState(pageAtom);
  const [isAuthState, setAuthState] = useRecoilState(isAuthAtom);
  const [webcamState, setWebcamState] = useRecoilState(webcamAtom);
  const [recordLocalState, setRecordLocalState] = useRecoilState(recordLocalAtom);
  const [recordType, setRecordTypeState] = useRecoilState(recordTypeAtom);
  const [modeSelectState, setModeSelectState] = useState(false);
  const isCloudRecordFinishedRef = useRef(false);

  //その他
  const oldDisplayNameRef = useRef(null);
  const [loadingState, setLoadingState] = useState(false);
  const [noMetaMaskState, setNoMetaMaskState] = useState(false);
  const [noNameErrorState, setNoNameErrorState] = useState(false);
  const [hatenaState, setHatenaState] = useState(false);
  const { t, i18n } = useTranslation();

  // useAudioLevel(audioTrack?.persistentTrack, (volume) => {
  //   console.log(Math.max(0.15, volume));
  // });

  //初期化
  useEffect(() => {}, []);

  //モード変更
  async function selectMode(mode) {
    if (mode == 'local') {
      setRecordTypeState('local');
    }

    if (mode == 'cloud') {
      setRecordTypeState('cloud');
    }
  }

  async function startRecording() {
    if (recordLocalState) {
      setRecordLocalState(false);
    } else {
      setRecordLocalState(true);
    }
  }

  //レンダー処理
  return (
    <>
      <div id="recordWrap">
        <div className={recordLocalState ? 'recordWrapInside recording' : 'recordWrapInside'}>
          {/*ラベル*/}

          {!recordLocalState && (
            <label htmlFor="username" className="hairCheckTitle" style={{ marginBottom: '10px' }}>
              {t('call.Save to')}
            </label>
          )}

          <div id="selectModeWrap">
            <div
              className={recordType == 'local' ? 'selectModeItem selected' : 'selectModeItem'}
              onClick={() => {
                selectMode('local');
              }}>
              <div className="selectModeIcon">
                <LocalBlack />
              </div>
              <div className="selectModeTitle">
                <>{t('call.Save to local')}</>
              </div>
            </div>
            <div
              className={recordType == 'cloud' ? 'selectModeItem selected' : 'selectModeItem'}
              onClick={() => {
                selectMode('cloud');
              }}>
              <div className="selectModeIcon">
                <CloudBlack />
              </div>
              <div className="selectModeTitle">
                <>{t('call.Save to cloud')}</>
              </div>
            </div>
          </div>

          {/* 参加ボタン */}
          <button onClick={startRecording} type="submit" className="btBase">
            {preAuthCompleteState ? (
              <> {!recordLocalState ? t('call.Start recording') : t('call.Stop')}</>
            ) : (
              <>
                <div id="selectLoader">
                  <svg className="circular-loader" viewBox="25 25 50 50">
                    <circle
                      className="loader-path"
                      cx="50"
                      cy="50"
                      r="20"
                      fill="none"
                      stroke="#70c542"
                      strokeWidth="2"
                    />
                  </svg>
                </div>
              </>
            )}
          </button>
        </div>
      </div>
    </>
  );
}
